// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__LXb6g","image":"styles_image__lpNZo","title":"styles_title__Hibtb","description":"styles_description__4xm1R","action":"styles_action__iuP8t"};